<template>
  <div>
    <vs-tabs :value="0" class="mb-4">
      <vs-tab label="정기안전보건 교육" />
      <vs-tab label="채용시 안전보건교육" @click="onClickTab(1)" />
    </vs-tabs>
    <vs-card>
      <div class="flex items-center justify-between p-2">
        <div class="flex items-center gap-5">
          <div style="width: 114px; font-size: 14px">연도</div>
          <vs-input type="number" v-model="연도" />
          <div style="width: 114px; font-size: 14px">반기</div>
          <search-nav-item-select v-model="반기" :list="[{ value: '상반기' }, { value: '하반기' }]" />
        </div>
        <vs-button color="secondary" @click="loadData">검색</vs-button>
      </div>
    </vs-card>
    <table>
      <colgroup>
        <col width="200" />
        <col width="100" />
      </colgroup>
      <thead>
        <tr>
          <th rowspan="2">구분</th>
          <th rowspan="2" style="background: #eaf4ff">학교(기관) 수</th>
          <th v-for="th in thead" :key="th" colspan="4" :class="th === '합계' && 'bg-FFF7E6'">{{ th }}</th>
        </tr>
        <tr>
          <fragment v-for="th in thead" :key="`sub_${th}`">
            <th :class="th === '합계' && 'bg-FFF7E6'">현원</th>
            <th :class="th === '합계' && 'bg-FFF7E6'">이수</th>
            <th :class="th === '합계' && 'bg-FFF7E6'">미이수</th>
            <th :class="th === '합계' && 'bg-FFF7E6'">이수율</th>
          </fragment>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, item_i) in list" :key="item.id">
          <td :class="item_i === 0 && 'bg-FFF7E6'">{{ item.id }}</td>
          <td>{{ item.기관수 }}</td>
          <fragment v-for="th in thead" :key="`${item_i}_sub_${th}`">
            <td :class="item_i === 0 && 'bg-FFF7E6'">{{ item[th].합계 }}</td>
            <td>{{ item[th].이수 }}</td>
            <td>{{ item[th].미이수 }}</td>
            <td>{{ item[th].이수율 }}%</td>
          </fragment>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect.vue";
import PopupExcelDownload from "@/popup/PopupExcelDownload.vue";

import HttpRequest from "@/util/HttpRequest";

export default {
  components: {
    FieldSelectModule,
    PopupPlanProject,
    DateSelector,
    PopupProjectSetting,
    MemberSelector,
    CompanySelector,
    FileUploader,
    FileUploadModule,
    SearchNavItemSelect,
    PopupExcelDownload,
  },
  data() {
    return {
      연도: new Date().getFullYear(),
      반기: "상반기",
      thead: ["급식종사자", "시설관리자", "통학차량관련자", "미화원", "당직전담원", "합계"],
      catDatas: [],
      list: [
        // {
        //   id: "합계",
        //   기관수: 0,
        //   급식종사자: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0 },
        //   시설관리자: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0 },
        //   통학차량관련자: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0 },
        //   미화원: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0 },
        //   당직전담원: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0 },
        //   합계: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0 },
        // },
      ],
    };
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return Number(this.$route.params.boardId.replace("_", ""));
    },
  },
  created() {
    this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "교육 현황" }, { title: "안전보건 교육 모니터링", active: true }]);
    this.loadData();
  },
  methods: {
    loadData() {
      const url = "/api/v1/summary/post/570";
      const params = { projectId: this.projectId, boardId: this.boardId, targetYear: Number(this.연도), targetHalf: this.반기 === "상반기" ? 1 : 2 };

      HttpRequest.get(url, { params }).then((response) => {
        let list = [];

        for (const key in response.employeeCount) {
          list.push({
            id: key,
            기관수: response.fieldCount[key],
            급식종사자: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0, ...response.employeeCount[key].급식종사자 },
            시설관리자: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0, ...response.employeeCount[key].시설관리자 },
            통학차량관련자: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0, ...response.employeeCount[key].통학차량관련자 },
            미화원: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0, ...response.employeeCount[key].미화원 },
            당직전담원: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0, ...response.employeeCount[key].당직전담원 },
            합계: { 합계: 0, 이수: 0, 미이수: 0, 이수율: 0, ...response.employeeCount[key].합계 },
          });
        }

        // list key:합계를 배열 가장 앞으로 이동
        list.sort((a, b) => {
          if (a.id === "합계") return -1;
          if (b.id === "합계") return 1;
          return 0;
        });

        // console.log("list", list);
        this.list = list;
      });
    },
    onClickTab(tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({
          name: "page|tab",
          params: { boardId: "_570", proj_id: this.projectId },
          meta: { activeCode: "570Monitoring" },
        });
      } else if (tabIndex === 1) {
        this.$router.push({
          name: "page|tab",
          params: { boardId: "_576", proj_id: this.projectId },
          meta: { activeCode: "570Monitoring" },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  margin-top: 68px;

  th,
  td {
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    border: 1px solid #cdcdcd;
    padding: 17px 4px;

    &.bg-FFF7E6 {
      background: #fff7e6;
    }
  }

  th {
    background: #fafafa;
  }
  td {
    background: white;
  }
}
</style>
